import { IUser } from '@sdk/contracts';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { handleInputValue } from '@/utils';

type Props = {
  teachers: Pick<IUser, '_id' | 'name' | 'lastName' | 'academy' | 'avatar'>[];
  value?: string;
  multiple?: boolean;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export const TeacherCourseSelector: React.FC<Props> = ({
  teachers,
  value,
  onChange,
  multiple,
  placeholder,
  allowClear = false,
  disabled = false
}) => {
  const { t } = useTranslation();

  return (
    <Select
      showSearch
      onChange={onChange}
      allowClear={allowClear}
      mode={multiple ? 'multiple' : undefined}
      value={handleInputValue(value, multiple)}
      placeholder={placeholder ?? t('SELECT_USER')}
      options={teachers.map(({ _id, name, lastName }) => ({
        label: `${name} ${lastName}`,
        value: _id
      }))}
      disabled={disabled}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
